/**
 * This is used for swapping out Bulk products for another
 */

import type { ProteinCalcProduct } from '@bulknutrients/bulk-shared-lib/interfaces/ProteinCalculator';
import { CustomImage } from '@components/Media/Image';
import type { ReactElement } from 'react';

export function ProductSelect({
  products,
  select,
}: {
  products: ProteinCalcProduct[];
  select: (sku: string) => void;
}): ReactElement {
  return (
    <div className="z-3 w-full rounded-sm bg-white p-[3vmin] shadow-[rgba(0,0,0,0.1)_0_10px_30px] dark:bg-grey-darkest">
      <div className="ProductSelect__Body">
        <h3 className="m-0 mb-4 text-center text-[#333] dark:text-grey-light">
          Select one of our other products to compare
        </h3>
        <div className="flex flex-wrap justify-center">
          {products.map((product, idx) => (
            <button
              className="group relative min-w-[180px] max-w-[220px] shrink
              grow basis-auto cursor-pointer p-[2vmin] 
              duration-200 hover:z-2
              hover:shadow-[0_10px_30px_0_rgba(0,0,0,0.1)] focus:z-2 focus:shadow-[0_10px_30px_0_rgba(0,0,0,0.1)] dark:bg-grey-dark"
              onClick={() => select(product.sku)}
              type="button"
              key={`${product.sku}-${idx}`}
            >
              <CustomImage image={product.image} width={140} height={160} />
              <h4 className="m-0 mb-1 text-center text-[#333] dark:text-grey-light">
                {product.name}
              </h4>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
